import { AccessTime } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CardHeader, Typography } from "@mui/material";
import moment, { Moment } from "moment";
import AccentPaper from "../../components/Paper";
import { TextInput } from "../../components/form/TextInput";
import { Charges } from "../../icons";
import { useCachedModel, useCachedStore, useIsMobile, useRemoteData } from "../../models/Hooks";
import { Bill } from "../../models/Types";
import { moneyFormat, parseValidDate } from "../../utils";
import { NavLinkComponent } from "../../Router";
import CachedStore, { CachedModel } from "../../models/CachedStore";

function DesktopWidget() {
    const [data] = useRemoteData<Bill[]>('BillActiveList');

    return <Card sx={{ flex: 1 }}>
        <CardHeader title="Квитанции на оплату" />
        <CardContent sx={{ gap: 2, display: 'flex', flexDirection: 'column', flex: 1 }}>
            {data?.map(x => <TextInput
                name={x.Id}
                onChange={e => { }}
                label={moment(x.CreateDate).format('MMMM Y')}
                value={x.Amount} />)}
            <Button variant="contained">Оплатить картой</Button>
            <Button variant="contained">Сформировать Квитанцию</Button>
        </CardContent>
    </Card>;
}

const postStoriesStore = CachedModel.ConfigureModel<{
    Amount: number
    LastBill: Moment
}>('BillAmount', 'BillAmount', 10 * 60);
function MobileWidget() {
    const [bill] = useCachedModel(postStoriesStore, x => {
        if (x) {
            const d = parseValidDate(x.LastBill);
            x.LastBill = d ? moment(d) : d;
        }

        return x;
    }, true);

    return <AccentPaper component={NavLinkComponent} route={[['page', 'bill']]} sx={{
        display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'space-between'
    }}>
        <Box display="flex" gap={1}>
            {bill?.Amount ? <>
                <Box>
                    <Typography variant="h2" mb={1.5}>{moneyFormat(bill?.Amount)}</Typography>
                    <Typography component="div" variant="body2" color="textSecondary">к оплате по вашему дому</Typography>
                </Box>
                <div style={{ width: 20 }}>
                    {Charges}
                </div>
            </> : <Box>
                <Typography variant="h2" mb={1.5} display="flex" justifyContent="space-between">Все оплачено
                    <div style={{ width: 20 }}>
                        {Charges}
                    </div></Typography>
                <Typography component="div" variant="body2" color="textSecondary">неоплаченных начислений нет</Typography>
            </Box>}
        </Box>
        {bill?.LastBill && false ? <Box sx={{ gap: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
            <Button variant="contained" color="info" startIcon={<AccessTime />} sx={{ fontSize: 8, p: 1 }}>
                Последнее начисление<br />
                {bill?.LastBill.calendar()}
            </Button>
            {/*<Button variant="contained">Оплатить</Button>*/}
        </Box > : null}
    </AccentPaper>;
}

export function BillWidget() {
    const ism = useIsMobile();
    return ism ? <MobileWidget /> : <DesktopWidget />;
}